import age from 'services/api/calculatorModals/age';
import care from 'services/api/calculatorModals/care';
import services from 'services/api/calculatorModals/services';
import pension from 'services/api/calculatorModals/pension';
import dayOne from 'services/api/calculatorModals/dayOne';
import education from 'services/api/calculatorModals/education';
import headsOfLoss from 'services/api/calculatorModals/headsOfLoss';
import interest from 'services/api/calculatorModals/interest';
import lifeExpectancy from 'services/api/calculatorModals/lifeExpectancy';
import multipliers from 'services/api/calculatorModals/multipliers';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'calculator-modals';

/**
 * Calculator Modal Endpoints:
 *
 */
export default {
    /**
     * Age Endpoints.
     *
     * @type {}
     */
    age,
    /**
     * Care Endpoints.
     *
     * @type {}
     */
    care,
    /**
     * Services Endpoints.
     *
     * @type {}
     */
    services,
    /**
     * Pension Endpoints.
     *
     * @type {}
     */
    pension,
    /**
     * Day One Endpoints.
     *
     * @type {}
     */
    dayOne,
    /**
     * Education Endpoints.
     *
     * @type {}
     */
    education,
    /**
     * Heads Of Loss Endpoints.
     *
     * @type {}
     */
    headsOfLoss,
    /**
     * Interest Endpoints.
     *
     * @type {}
     */
    interest,
    /**
     * Life Expectancy Endpoints.
     *
     * @type {}
     */
    lifeExpectancy,
    /**
     * Multipliers Endpoints.
     *
     * @type {}
     */
    multipliers,
};



// WEBPACK FOOTER //
// ./src/services/api/calculatorModals.js